import { createStore } from "vuex";

const store = createStore({
    state: {
        isScrolling: false,
        scrollSpeed: 1
    }
})

export default store;